<template>
    <div class="search">
        <div class="search__field">
            <input
                type="search"
                name="search"
                class="field field--icon bg-icon bg-icon--search"
                ref="input"
                autocomplete="off"
                placeholder="Search by location or keyword"
                v-on:input="handleSearchInput"
                v-on:keyup.enter="handleSearchSubmit"
            />

            <div
                class="search__suggestions"
                v-bind:class="{ show: suggestList.length > 0 }"
            >
                <button
                    v-for="item in suggestList"
                    v-on:click="handleResultClick(item)"
                    :key="'suggest-item-' + item.type + '-' + item.title"
                >
                    <search-suggestion v-bind="item"></search-suggestion>
                </button>
            </div>
        </div>

        <ul class="search__key-filters">
            <li
                v-for="item in keyFilters"
                :key="'key-filter-item-' + item.type + '-' + item.title"
            >
                <key-filter
                    v-bind:value="item.value"
                    v-bind:title="item.title"
                    v-bind:type="item.type"
                ></key-filter>
            </li>
        </ul>

        <div class="search__results">
            <div>
                Found
                <strong>{{ this.$store.getters.filteredCandidates.length }}</strong>
                Candidate{{ this.$store.getters.filteredCandidates.length > 1 ? "s" : "" }}
            </div>

            <ul class="results" data-el-query="650">
                <li
                    class="results__item"
                    v-for="item in resultsList"
                    :key="'candidate-' + item.id"
                >
                    <candidate
                        v-bind:id="item.id"
                        v-bind:jobId="item.jobId"
                        v-bind:title="item.title"
                        v-bind:location="item.location"
                        v-bind:text="item.description"
                        v-bind:url="item.url"
                        v-bind:owners="item.owners"
                    ></candidate>
                </li>
            </ul>
        </div>

        <div class="search__pagination" v-if="pageCount > 1">
            <nav>
                <paginate
                    :value="currentPage"
                    :page-count="pageCount"
                    :page-range="3"
                    :margin-pages="1"
                    :click-handler="handlePaginateClick"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-item'"
                    :prev-link-class="'page-link'"
                    :next-class="'page-item'"
                    :next-link-class="'page-link'"
                    :break-view-class="'page-item'"
                    :break-view-link-class="'page-link'"
                    :active-class="'current'"
                >
                </paginate>
            </nav>
        </div>
    </div>
</template>

<script>
import SearchSuggestion from "./search-suggestion.vue";
import KeyFilter from "./key-filter.vue";
import Candidate from "./candidate.vue";

import Fuse from "fuse.js";
import Paginate from "vuejs-paginate";

export default {
    data: function () {
        return {
            suggestList: [],
        };
    },
    components: {
        SearchSuggestion,
        KeyFilter,
        Candidate: Candidate,
        Paginate,
    },
    updated: function () {
        // elQueries();
    },
    computed: {
        searchList: function () {
            const searchList = [];

            // Loop through all locations in state
            for (const l of this.$store.state.locations) {
                // If location not already selected, add to list
                if (
                    this.$store.state.selectedFilters.locations.filter(
                        (e) => e.id === l.id
                    ).length === 0
                ) {
                    // Work out number of jobs for this location, based on other selected filters

                    // Get all candidates
                    let arr = this.$store.state.candidates;

                    // Loop through keys in selected filters
                    for (const fk in this.$store.state.selectedFilters) {
                        // Ignore locations filter
                        if (fk !== "locations") {
                            const filterUsing = fk === "terms" ? "title" : fk;

                            for (const fv of this.$store.state.selectedFilters[
                                fk
                            ]) {
                                arr = arr.filter((item) => {
                                    return item[filterUsing].includes(fv);
                                });
                            }
                        }
                    }

                    // Calculate number of jobs for location
                    arr = arr.filter((item) => {
                        return item.locations.includes(l.id);
                    });

                    if (arr.length > 0) {
                        searchList.push({
                            type: "location",
                            id: l.id,
                            title: l.title,
                            number: arr.length,
                        });
                    }
                }
            }

            for (const j of this.$store.getters.filteredCandidates) {
                // Add job title not already in list AND not already selected
                if (
                    searchList.filter((e) => e.title === j.title).length ===
                        0 &&
                    this.$store.state.selectedFilters.terms.filter(
                        (e) => e.title === j.title
                    ).length === 0
                ) {
                    searchList.push({
                        type: "term",
                        title: j.title,
                    });
                }
            }

            return searchList;
        },
        keyFilters: function () {
            const arr = [];

            // Add selected locations
            for (const f of this.$store.state.selectedFilters.locations) {
                // Get location object from state based on id
                const l = this.$store.state.locations.find(
                    ({ id }) => id === f
                );

                if (l !== undefined) {
                    arr.push({
                        value: l.id,
                        title: l.title,
                        type: "location",
                    });
                }
            }

            // Add selected job titles
            for (const f of this.$store.state.selectedFilters.terms) {
                arr.push({
                    value: f,
                    title: f,
                    type: "term",
                });
            }

            return arr;
        },
        resultsList: function () {
            const startIndex =
                (this.$store.state.currentPage - 1) * this.$store.state.perPage;
            const endIndex = startIndex + this.$store.state.perPage;

            return this.$store.getters.filteredCandidates.slice(startIndex, endIndex);
        },
        pageCount: function () {
            return Math.ceil(
                this.$store.getters.filteredCandidates.length /
                    this.$store.state.perPage
            );
        },
        currentPage: function () {
            return this.$store.state.currentPage;
        },
    },
    methods: {
        handleSearchInput(e) {
            const term = e.target.value;
            const arrResults = [];

            if (term.length > 1) {
                const fuse = new Fuse(this.searchList, {
                    includeScore: true,
                    minMatchCharLength: 2,
                    threshold: 0.3,
                    keys: ["title"],
                });

                const results = fuse.search(term);
                for (const r of results) {
                    arrResults.push(r.item);
                }
            }

            this.suggestList = arrResults;
        },
        handleResultClick(item) {
            let itemValue = null;

            switch (item.type) {
                case "location":
                    itemValue = item.id;
                    break;
                case "term":
                    itemValue = item.title;
            }

            // Trigger mutation to save selected item to keyFilters in state
            this.$store.commit("filterSelect", {
                type: item.type,
                value: itemValue,
            });

            // Get search field, empty it and trigger the 'input' event on it
            const searchFld = this.$refs.input;
            searchFld.value = "";
            const e = new Event("input");
            searchFld.dispatchEvent(e);
        },
        handleSearchSubmit(e) {
            // Trigger mutation to save selected item to keyFilters in state
            this.$store.commit("filterSelect", {
                type: "term",
                value: e.target.value,
            });

            // Get search field, empty it and trigger the 'input' event on it
            const searchFld = this.$refs.input;
            searchFld.value = "";
            const ev = new Event("input");
            searchFld.dispatchEvent(ev);
        },
        handlePaginateClick(page) {
            this.$store.commit("pageChange", page);
        },
    },
};
</script>
